export default "__VITE_ASSET__CCVKV2hc__"